import { defineEffect } from '../../../core/effect';

/**
 * **対象の印を消す**（Issue #534）。
 *
 * `become_target` が置いた照準を消すだけのファイル。**消すのは閉じるイベントの仕事**
 * （設計文書 §1.2）—— 旧 `components/fx` では `target.js` が `build` で未来のイベントを
 * 探して `endRow` を決めていたが、1 ファイル = 1 イベントではその必要が無い。
 *
 * 絵を持たないので `layers` は無い（帯も作らない）。
 */
export default defineEffect({
  situation: 'chain_solved',
  label: '対象の印を消す',

  /** `key` を省くとその印を**全部**消す（綴りは器が組むので知らなくてよい） */
  clears: () => [{ mark: 'target' }, { mark: 'processing' }],
}, 'chain_solved_effect.js');
